// LIBRERIE/IMPORTS
import { Helmet } from "react-helmet";
import he from 'he';

// HOOKS
import { useTranslation } from "react-i18next";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";

interface AboutUsProps {
    agencyId: number;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId }) => {
    const { t } = useTranslation();
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.head.metaTitle')} | {he.decode(`${agency?.agencyName}`)}</title>
                <meta name="description" content={t('aboutUsPage.head.metaDescription') as string} />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb">
                <div className="container-fluid w-special">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <div>
                                <h2 className="mb-3">
                                    <span>{t('aboutUsPage.title1')}</span>
                                </h2>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para6') as string }}></p>
                            </div>
                        </div>
                        <div className="col-12 col-xl-6 order-lg-2">
                            <div className="mb-5">
                                <h2 className="mb-3">
                                    <span>{t('aboutUsPage.title2')}</span>
                                </h2>
                                <ul>
                                    <li>
                                        <h3>{t('aboutUsPage.listItem1Title')}</h3>
                                        <p>{t('aboutUsPage.listItem1Description')}</p>
                                    </li>
                                    <li>
                                        <h3>{t('aboutUsPage.listItem2Title')}</h3>
                                        <p>{t('aboutUsPage.listItem2Description')}</p>
                                    </li>
                                    <li>
                                        <h3>{t('aboutUsPage.listItem3Title')}</h3>
                                        <p>{t('aboutUsPage.listItem3Description')}</p>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h2 className="mb-3">
                                    <span>{t('aboutUsPage.title3')}</span>
                                </h2>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para7') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para8') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para9') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para10') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para11') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para12') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para13') as string }}></p>
                                <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para14') as string }}></p>
                            </div>
                        </div>
                        <div className="col-12 col-xl-6 mb-4 mb-xl-0 text-center order-lg-1">
                            <img src="/assets/images/altrePag/rollo.jpg" alt={t('aboutUsPage.imageAlt1') as string} className="img-fluid mb-3" />
                            <img src="/assets/images/altrePag/sede.jpg" alt={t('aboutUsPage.imageAlt2') as string} className="img-fluid" />
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};
export default AboutUs;